
import React from "react";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/C9.jpg";
import img2en from "./imgs/MC9.jpeg";
import img3en from "./imgs/17-M-Cure 9.jpg";

export function MCure9() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                    <img className="product-img" src={img3en}/>
                </>
            }
        </>
    )
}